import React, { useState } from 'react';
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Button,
  Grid,
} from '@mui/material';
import { AppConfig } from 'src/config/AppConfig';

const OperatingHoursPicker: React.FC = ({
  onApply,
  handleClose,
}: {
  onApply: (value: {
    name: 'allDay' | 'businessHours' | 'custom';
    from: 'string';
    to: 'string';
  }) => void;
  handleClose: () => void;
}) => {
  const [selectedOption, setSelectedOption] = useState<
    'allDay' | 'businessHours' | 'custom'
  >('allDay');
  const [fromTime, setFromTime] = useState<string>(AppConfig.allDay.from);
  const [toTime, setToTime] = useState<string>(AppConfig.allDay.to);

  // Array for 30-minute intervals for the day
  const timeSlots = Array.from({ length: 49 }, (_, index) => {
    const hours = Math.floor(index / 2);
    const minutes = index % 2 === 0 ? '00' : '30';
    return `${String(hours).padStart(2, '0')}:${minutes}`;
  });

  const handleChangeOption = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedOption(event.target.value as 'allDay' | 'businessHours');
    if (
      event.target.value === 'allDay' ||
      event.target.value === 'businessHours'
    ) {
      setFromTime(AppConfig.allDay.from);
      setToTime(AppConfig.allDay.to);
    }
  };

  const handleChangeFromTime = (
    event: React.ChangeEvent<{ value: unknown }>,
  ) => {
    setFromTime(event.target.value as string);
    setSelectedOption('custom');
  };

  const handleChangeToTime = (event: React.ChangeEvent<{ value: unknown }>) => {
    setToTime(event.target.value as string);
    setSelectedOption('custom');
  };

  const handleApply = () => {
    console.log(fromTime, toTime);
    onApply({ name: selectedOption, from: fromTime, to: toTime });

  };

  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={3}>
        {/* First Dropdown: All Day or Business Hours */}
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth>
            <InputLabel>Operating Hours</InputLabel>
            <Select
              value={selectedOption}
              onChange={handleChangeOption}
              label="Operating Hours"
            >
              <MenuItem value="allDay">All Day</MenuItem>
              <MenuItem value="businessHours">Business Hours</MenuItem>
              <MenuItem value="custom">custom range</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {/* Second Dropdown: Time Slot for All Day */}
        <>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>From</InputLabel>
              <Select
                value={fromTime}
                onChange={handleChangeFromTime}
                label="From"
              >
                {timeSlots.map((time) => (
                  <MenuItem key={time} value={time}>
                    {time}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>To</InputLabel>
              <Select value={toTime} onChange={handleChangeToTime} label="To">
                {timeSlots.map((time) => (
                  <MenuItem key={time} value={time}>
                    {time}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </>
        {/* Apply and Cancel Buttons */}
        <Grid item xs={12}>
          <Button
            variant="outlined"
            sx={{ marginRight: 2 }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleApply}>
            Apply
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OperatingHoursPicker;
